import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material';
var AppIcon = function (_a) {
    var icon = _a.icon;
    var IconElement = styled(icon)(function (_a) {
        var theme = _a.theme;
        return ({
            fill: theme.palette.textIcon.primary,
            filter: 'unset !important',
            path: {
                fill: theme.palette.textIcon.primary,
            },
        });
    });
    return _jsx(IconElement, {});
};
export default AppIcon;
